export default __webpack_public_path__ + "static/media/logo.e1389992.png";